/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Fixed_Weekdays_4Inputs */

const en_us2_onboarding_fixed_weekdays_4 = /** @type {(inputs: Onboarding_Fixed_Weekdays_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thursday`)
};

const pt_br2_onboarding_fixed_weekdays_4 = /** @type {(inputs: Onboarding_Fixed_Weekdays_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quinta`)
};

const es_419_onboarding_fixed_weekdays_4 = /** @type {(inputs: Onboarding_Fixed_Weekdays_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jueves`)
};

const pt_pt2_onboarding_fixed_weekdays_4 = /** @type {(inputs: Onboarding_Fixed_Weekdays_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quinta`)
};

const fr_fr2_onboarding_fixed_weekdays_4 = /** @type {(inputs: Onboarding_Fixed_Weekdays_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeudi`)
};

const de_de2_onboarding_fixed_weekdays_4 = /** @type {(inputs: Onboarding_Fixed_Weekdays_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donnerstag`)
};

const it_it2_onboarding_fixed_weekdays_4 = /** @type {(inputs: Onboarding_Fixed_Weekdays_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giovedì`)
};

/**
* | output |
* | --- |
* | "Thursday" |
*
* @param {Onboarding_Fixed_Weekdays_4Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_fixed_weekdays_4 = /** @type {((inputs?: Onboarding_Fixed_Weekdays_4Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Fixed_Weekdays_4Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_fixed_weekdays_4(inputs)
	if (locale === "es-419") return es_419_onboarding_fixed_weekdays_4(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_fixed_weekdays_4(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_fixed_weekdays_4(inputs)
	if (locale === "de-DE") return de_de2_onboarding_fixed_weekdays_4(inputs)
	if (locale === "it-IT") return it_it2_onboarding_fixed_weekdays_4(inputs)
	return en_us2_onboarding_fixed_weekdays_4(inputs)
});
export { onboarding_fixed_weekdays_4 as "onboarding.fixed_weekdays.4" }